import Actions from './promotion-actions';
import Api from './promotion-api';
import Collection from './promotion-collection';
import Model from './promotion-model';
import reducer from './promotion-reducer';
import sagas from './promotion-sagas';
import Selectors from './promotion-selectors';
import * as Enums from './promotion-enums';
import * as Utils from './promotion-utils';

export default {
  Actions,
  Api,
  Collection,
  Model,
  namespace: 'promotions',
  reducer,
  sagas:     [sagas],
  Selectors,
  Utils,
  Enums,
};
